import { useState, useCallback } from "react";

/**
 * useFileViewer
 *
 * Usage:
 *   const { viewerFile, openFile, closeFile } = useFileViewer();
 *
 *   <div onClick={() => openFile(file)}>filename.png</div>
 *
 *   {viewerFile && (
 *     <FileViewerModal
 *       url={viewerFile.url}
 *       fileId={viewerFile.fileId}
 *       subjectId={viewerFile.subjectId}
 *       onClose={closeFile}
 *     />
 *   )}
 */
const useFileViewer = () => {
  const [viewerFile, setViewerFile] = useState(null);

  // Pass the full file object: { url, fileId, subjectId }
  const openFile  = useCallback((file) => setViewerFile(file), []);
  const closeFile = useCallback(() => setViewerFile(null), []);

  return { viewerFile, openFile, closeFile };
};

export default useFileViewer;